if (!customElements.get("quantity-input")) {
  customElements.define(
    "quantity-input",
    class QuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });

        // Use a more robust event listener setup
        this.setupEventListeners();

        // Initialize quantity rules validation after a short delay
        setTimeout(() => {
          this.validateQtyRules();
        }, 10);
      }

      connectedCallback() {
        // Ensure initialization when element is added to DOM
        if (!this.initialized) {
          this.initialized = true;
          this.validateQtyRules();
        }
      }

      setupEventListeners() {
        if (this.input) {
          this.input.addEventListener("change", this.onInputChange.bind(this));
        }

        // Use event delegation for better reliability
        this.addEventListener("click", (event) => {
          // Check if clicked element is a button or inside a button
          const button = event.target.closest(
            'button[name="plus"], button[name="minus"]',
          );
          if (button) {
            this.onButtonClick(event, button);
          }
        });
      }

      onInputChange(event) {
        this.validateQtyRules();
      }

      onButtonClick(event, button = null) {
        event.preventDefault();
        event.stopPropagation();

        // Use the passed button or fall back to event target
        const targetButton = button || event.target;

        // Check if button is disabled
        if (targetButton.classList.contains("disabled")) {
          return;
        }

        const previousValue = parseInt(this.input.value) || 0;
        const step = parseInt(this.input.step) || 1;
        const min = parseInt(this.input.min) || 0;
        const max = parseInt(this.input.max) || Infinity;

        let newValue = previousValue;

        if (targetButton.name === "plus") {
          newValue = Math.min(previousValue + step, max);
        } else {
          newValue = Math.max(previousValue - step, min);
        }

        if (newValue !== previousValue) {
          this.input.value = newValue;
          this.input.dispatchEvent(this.changeEvent);
          this.validateQtyRules();
        }
      }

      validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
          const min = parseInt(this.input.min);
          const buttonMinus = this.querySelector(
            ".quantity__button[name='minus']",
          );
          buttonMinus.classList.toggle("disabled", value <= min);
        }
        if (this.input.max) {
          const max = parseInt(this.input.max);
          const buttonPlus = this.querySelector(
            ".quantity__button[name='plus']",
          );
          buttonPlus.classList.toggle("disabled", value >= max);
        }
      }
    },
  );
}
